<template>
  <div class="flex text-gray-600 ota-p16 shadow-md border-t border-b border-gray-200 relative md:border-t-0 md:shadow-none md:border-b-2">
    <div
      class="flex-1 text-center py-3 transition-colors ease-in duration-200"
      :class="[isCompleted ? 'text-green-400' : 'text-orange-300']"
      :to="$i18n.localePath({ name: 'webshop-checkout-shipping' })"
    >
      {{ $t('Loyalty.Webshop.Checkout.Shipping') }}
    </div>
    <div
      class="flex-1 text-center py-3 transition-colors ease-in duration-200"
      :class="{
        'text-orange-300': activeIndex > 0 && !isCompleted,
        'text-green-400': activeIndex > 0 && isCompleted
      }"
      :to="$i18n.localePath({ name: 'webshop-checkout-payment' })"
    >
      {{ $t('Loyalty.Webshop.Checkout.ShippingCosts') }}
    </div>
    <div
      class="flex-1 text-center py-3 transition-colors ease-in duration-200"
      :class="{
        'text-orange-300': activeIndex > 1 && !isCompleted,
        'text-green-400': activeIndex > 1 && isCompleted
      }"
    >
      {{ $t('Loyalty.Webshop.Checkout.Confirmation') }}
    </div>
    <div class="line-container absolute w-full bottom-0 left-0">
      <div
        class="w-full line transform transition-transform ease-in duration-200 origin-left"
        :class="[isCompleted ? 'bg-green-400' : 'bg-orange-300']"
        :style="{
          '--transform-scale-x': scalePercentage
        }"
      />
      <div
        class="circle absolute transform transition-all ease-in duration-200 rounded-full"
        :class="[isCompleted ? 'bg-green-400' : 'bg-orange-300']"
        :style="{
          left: `calc(${scalePercentage * 100}% - .3rem)`
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebshopCheckoutHeader',
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    scalePercentage () {
      if (this.activeIndex === 1) {
        return 0.5
      }

      if (this.activeIndex === 2) {
        return 1
      }

      return 0.166666666667
    },
    isCompleted () {
      return this.scalePercentage === 1
    }
  }
}
</script>

<style lang="postcss" scoped>
>>> .active {
  @apply text-orange-300;
}

.line {
  height: .2rem;
}

.circle {
  height: .6rem;
  width: .6rem;
  bottom: -0.2rem;
}

@screen md {
  .line-container {
    bottom: -0.2rem;
  }
}
</style>
